/**
 * @generated SignedSource<<142b6527b4553e1e0f848a9217d50cb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type STATUS_CATEGORY = "TODO" | "INPROGRESS" | "DONE" | "%future added value";
export type SendTasksToJiraInput = {
  ids?: ReadonlyArray<string | null> | null;
  jiraIssueTypeId?: string | null;
  jiraSubtaskIssueTypeId?: string | null;
  jiraType?: string | null;
  jiraEpicId?: string | null;
  customFields?: ReadonlyArray<JiraCustomFieldInputType | null> | null;
  syncHierarchy?: boolean | null;
  firstLevelAsEpic?: boolean | null;
  epicIssueTypeId?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type JiraCustomFieldInputType = {
  key?: string | null;
  value?: string | null;
};
export type sendTasksToJiraMutation$variables = {
  input: SendTasksToJiraInput;
};
export type sendTasksToJiraMutation$data = {
  readonly sendTasksToJira: {
    readonly tasks: ReadonlyArray<{
      readonly id: string;
      readonly jiraId: string | null;
      readonly jiraKey: string | null;
      readonly name: string | null;
      readonly statusColumnV2: {
        readonly id: string;
        readonly name: string | null;
        readonly category: STATUS_CATEGORY | null;
      } | null;
      readonly phase: {
        readonly id: string;
      } | null;
    } | null> | null;
    readonly updatedTasksIds: ReadonlyArray<string | null> | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type sendTasksToJiraMutation = {
  variables: sendTasksToJiraMutation$variables;
  response: sendTasksToJiraMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SendTasksToJiraPayload",
    "kind": "LinkedField",
    "name": "sendTasksToJira",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "kind": "LinkedField",
        "name": "tasks",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jiraId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "jiraKey",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StatusColumnV2",
            "kind": "LinkedField",
            "name": "statusColumnV2",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "category",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PhaseType",
            "kind": "LinkedField",
            "name": "phase",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "updatedTasksIds",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sendTasksToJiraMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "sendTasksToJiraMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "6c93beae5fe60af4ea377647a95fabff",
    "id": null,
    "metadata": {},
    "name": "sendTasksToJiraMutation",
    "operationKind": "mutation",
    "text": "mutation sendTasksToJiraMutation(\n  $input: SendTasksToJiraInput!\n) {\n  sendTasksToJira(input: $input) {\n    tasks {\n      id\n      jiraId\n      jiraKey\n      name\n      statusColumnV2 {\n        id\n        name\n        category\n      }\n      phase {\n        id\n      }\n    }\n    updatedTasksIds\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "6261c2d2bf40f3868f980e91f0522964";

export default node;
